import { create } from 'zustand';
import { emit } from '@/lib/events';

const MAX_COMPARE = 5;

interface CompareState {
  istats: string[];
  toggle: (istat: string) => void;
  clear: () => void;
}

export const useCompareStore = create<CompareState>((set, get) => ({
  istats: [],

  toggle: (istat) => {
    const { istats } = get();
    if (istats.includes(istat)) {
      const next = istats.filter((i) => i !== istat);
      set({ istats: next });
      emit('compare:toggled', { on: false, total: next.length });
    } else if (istats.length < MAX_COMPARE) {
      const next = [...istats, istat];
      set({ istats: next });
      emit('compare:toggled', { on: true, total: next.length });
    }
  },

  clear: () => set({ istats: [] }),
}));

export const MAX_COMPARE_ITEMS = MAX_COMPARE;
